// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { zora as _zora } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the zora chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 7777777
 * Chain Name: Zora
 * Default Block Explorer: https://explorer.zora.energy
 * Default RPC URL: https://rpc.zora.energy
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { zora } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: zora,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const zora = createCommon({
	..._zora,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
